// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "WhatsappButton-module--arrow-up-and-down--7c729";
export var icon = "WhatsappButton-module--icon--b4149";